import { RegularList } from "./regularList";
import { Nav } from "./navbar/nav";
import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { HiPlus } from "react-icons/hi";
import { BiWindows } from "react-icons/bi";
import "./lists.css";
import { getAllLists } from "../api-interactions/lists";
import { getCookie } from "../helperFunctions/cookie";
import { Navigate } from "react-router";
import { CreateList } from "./create-list";

export const Lists = () => {
  const [lists, setLists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createList, setCreateList] = useState(false);
  const jwt = getCookie();

  const getLists = async () => {
    setLoading(true);
    try {
      const lists = await getAllLists(jwt);
      setLists(lists.data.data.lists);
    } catch {
      <Navigate to="/signin" />;
    }
    setLoading(false);
  };

  useEffect(() => {
    getLists();
  }, []);

  return (
    <>
      <Nav />

      {createList ? (
        <Backdrop open="open" id="backdrop">
          <CreateList
            lists={lists}
            setLists={setLists}
            setCreateList={setCreateList}
          />
        </Backdrop>
      ) : (
        <div id="all-lists-container">
          <div id="all-lists-header-container">
            <h2 id="all-lists-title">All Lists</h2>
            <div id="all-lists-btn-container">
              <button id="new-list-btn" onClick={() => setCreateList(true)}>
                <HiPlus id="new-list-btn-icon" />
                <p id="new-list-btn-text">New</p>
              </button>
              <button id="rearrange-list-btn">
                <BiWindows id="rearrange-list-btn-icon" />
                <p id="rearrange-list-btn-text">Rearrange</p>
              </button>
            </div>
          </div>
          <h3 className="lists-section-title">Public lists:</h3>
          <div id="lists-container">
            <div>
              {!loading && (
                <div id="public-lists-container">
                  {lists.map((list) => {
                    let listType;
                    if (list.public) {
                      switch (list.type) {
                        case "RegularList":
                          listType = (
                            <RegularList
                              key={list.id}
                              listId={list.title}
                              list={list}
                              items={list.items}
                              needAccept={list.needAccept}
                            />
                          );
                          break;
                        default:
                          listType = (
                            <RegularList
                              key={list.id}
                              list={list}
                              listId={list.title}
                              items={list.items}
                              needAccept={list.needAccept}
                            />
                          );
                          break;
                      }
                      return <div key={list.id}>{listType}</div>;
                    }
                  })}
                </div>
              )}
            </div>

            <h3 className="lists-section-title">Private lists:</h3>
            <div>
              {!loading && (
                <div id="private-lists-container">
                  {lists.map((list) => {
                    if (!list.public) {
                      let listType;
                      switch (list.type) {
                        case "RegularList":
                          listType = (
                            <RegularList
                              key={list.id}
                              listId={list.title}
                              list={list}
                              items={list.items}
                              needAccept={list.needAccept}
                            />
                          );
                          break;
                        default:
                          listType = (
                            <RegularList
                              key={list.id}
                              list={list}
                              listId={list.title}
                              items={list.items}
                              needAccept={list.needAccept}
                            />
                          );
                          break;
                      }
                      return <div key={list.id}>{listType}</div>;
                    }
                  })}
                </div>
              )}
            </div>
            {loading && (
              <Backdrop open="open" id="loading-backdrop">
                <CircularProgress color="primary" />
              </Backdrop>
            )}
          </div>
        </div>
      )}
    </>
  );
};
